import React from 'react'
import moment from 'moment'
import { format, parseISO } from 'date-fns'
import { Seat, Bag } from 'pcln-icons'
import { getPartOfDay } from '../../ExpressDealSlice/TimeWindow'
import { vipSavingsPercent, budgetSaverWeChooseCopy } from './expressDealConstants'
import { SignedOutHeaderText } from './SignedOutHeaderText'

const getAncillaries = (slices) => {
  const bag = slices.every((slice) => slice.carryOnBagOption === 'INCLUDED')
  const seat = slices.every((slice) => slice.seatSelectionOption === 'INCLUDED')
  if (bag) {
    return {
      icons: [Bag],
      description: 'Carry-on bag included!',
    }
  } else if (seat) {
    return {
      icons: [Seat],
      description: 'Advance seat selection may be included.',
    }
  }
  return null
}

const getAltDateInfo = (itinerary, searchRequest, index) => {
  const displayDate = itinerary.alternateDatesTexts?.dateRange?.split(/\u2013/)?.[index]
  const searchDate = searchRequest?.slices?.[index]?.travelDate
  const formattedSearchDate = searchDate ? format(parseISO(searchDate), 'eee, MMM d') : null
  const isAltDate = displayDate?.trim() !== formattedSearchDate
  return {
    displayDate,
    isAltDate,
  }
}

const getSlices = (itinerary, searchRequest) =>
  itinerary.slice.map((slice, index) => ({
    departure: slice.originAirportCode || slice.origin.code,
    arrival: slice.destinationAirportCode || slice.destination.code,
    isOvernight: slice.mayArriveNextDay,
    altOriginAirport: slice.alternateOriginAirport,
    altDestinationAirport: slice.alternateDestinationAirport,
    takeoff: getPartOfDay(moment(slice.departureWindow?.start).format('ha').toLowerCase().slice(0, -1)),
    ...getAltDateInfo(itinerary, searchRequest, index),
  }))

const getAirlines = (exdCarriers) =>
  exdCarriers.map((carrier) => ({
    name: carrier.name,
    logo: `https://s1.pclncdn.com/design-assets/fly/carrier-logos/${carrier.image}`,
  }))

const getHeaderText = (userLoggedIn, savings = {}, enableExpressDealVip) => {
  return userLoggedIn && enableExpressDealVip ? (
    `Congrats, you've unlocked VIP deals!`
  ) : (
    <SignedOutHeaderText {...savings} />
  )
}

const formatPrice = (price) => ({
  dollars: price.dollar,
  cents: price.cents,
  total: price.price,
})

const formatPriceWithVip = ({ totalFare, baseFare = 0 }) => {
  const price = totalFare - baseFare * 0.05
  const priceComponents = price.toFixed(2).split('.')
  return {
    dollars: priceComponents[0],
    cents: priceComponents[1],
    total: price,
  }
}

export const getBudgetSaverCopy = (percentage) => {
  let { tag, shortCopy, longCopy } = budgetSaverWeChooseCopy
  const suffix = percentage > 0 ? `${percentage}%` : 'money.'
  shortCopy = shortCopy + suffix
  longCopy = longCopy + suffix
  return { tag, shortCopy, longCopy }
}

const getExdProps = ({
  onExdClick,
  userLoggedIn,
  itinerary,
  exdCarriers,
  openLoginModal,
  vipTier,
  pclnExpt,
  isFireFly,
  enableExpressDealVip,
  searchRequest,
}) => ({
  airlinesDescription: "You're guaranteed to get one of these airlines",
  vipSavingsPercent,
  budgetSaver: getBudgetSaverCopy(itinerary?.pricingInfo?.savings?.inPercent),
  promptSignIn: !userLoggedIn && openLoginModal,
  headerText: getHeaderText(userLoggedIn, itinerary?.pricingInfo?.savings, enableExpressDealVip),
  price:
    userLoggedIn && !isFireFly
      ? formatPriceWithVip(itinerary.pricingInfo)
      : formatPrice(itinerary.totalPriceWithDecimal),
  ancillaries: getAncillaries(itinerary.slice),
  airlines: getAirlines(exdCarriers),
  slices: getSlices(itinerary, searchRequest),
  onClick: onExdClick,
  vipTier,
  pclnExpt,
  isFireFly,
  enableExpressDealVip,
})

export { getExdProps }
